import React, { Fragment, useEffect, useState } from "react";
import HeaderComponent from "../../components/HeaderComponent";
import TitleH2Component from "../../components/TitleH2Component";
import InputComponent from "../../components/InputComponent";
import stylebtn from "../../styles/btn.module.scss";
import PaginadorComponent from "../../components/PaginadorComponent";
import LoaderComponent from "../../components/LoaderComponent";
import AlertComponent from "../../components/AlertComponent";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import {
  deleteVentaRapidas,
  editarFechaV,
  getVentaRapidas,
} from "../../api/ApiVenta";
import { useFormatter } from "../../hooks/useFormatter";
import ModalGeneralComponent from "../../components/ModalGeneralComponent";
import ParrafoComponent from "../../components/ParrafoComponent";
import TitleH4Component from "../../components/TitleH4Component";

const CotizacionRealizadasPages = () => {
  //Data de paginador
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState(false);
  const [ventas, setVentas] = useState([]);
  const { formatDate, formatDateUTC } = useFormatter();
  const [busqueda, setBusqueda] = useState("");
  const [showEliminar, setShowEliminar] = useState(false);
  const [id, setId] = useState(false);
  const [mensajealerta, setMensajealerta] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [show, setShow] = useState(false);
  const [mensaje, setMensaje] = useState("");
  const [showFechaModal, setShowFechaModal] = useState(false);
  const [currentFactura, setCurrentFactura] = useState({});
  const [formDataFecha, setFormDataFecha] = useState({
    fecha_vencimiento: "",
    fecha_creacion: "",
  });
  const [formDataFechaBusqueda, setFormDataFechaBusqueda] = useState({
    fechaI: "",
    fechaFin: "",
  });

  const isCotizacion = "cotizacion";
  const navigate = useNavigate();
  const location = useLocation();
  // Manejar el cambio en el input
  const handleChangeBusqueda = (event) => {
    setBusqueda(event.target.value);
  };

  const itemsPerPage = 7;
  const pageCount = Math.ceil(ventas.length / itemsPerPage);
  const currentPageDateVR = ventas.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage
  );

  // Manejar el cambio en el input
  const handleInputChangeFechaBusqueda = (e) => {
    setFormDataFechaBusqueda({
      ...formDataFechaBusqueda,
      [e.target.name]: e.target.value,
    });
  };
  // Manejar el cambio en el input
  const handleInputChangeFecha = (e) => {
    setFormDataFecha({
      ...formDataFecha,
      [e.target.name]: e.target.value,
    });
  };

  //Metodo para obtener las ventas rapidas
  const ventasrapidas = async (filters = {}) => {
    setLoading(true);
    const { status, res } = await getVentaRapidas(filters);
    if (status === 200) {
      setVentas(res?.data); // guardas ventas en el estado
    } else {
      console.error("Error:", res?.data);
    }
    setLoading(false);
  };

  useEffect(() => {

    const params = new URLSearchParams(location.search);
    const query = params.get("search") || "";
    setBusqueda(query);
    const filters = {
      isVenta: isCotizacion,
      searchQuery: query
    };
    ventasrapidas(filters);
  }, [location.search, isCotizacion]);

  // metodo para filtrar un producto de la factura venta rapida
  const handleFilterClick = (e) => {
    e.preventDefault();
    let fechaFin = formDataFechaBusqueda.fechaFin
      ? new Date(formDataFechaBusqueda.fechaFin)
      : null;
    let endDate = null;
    if (fechaFin instanceof Date && !isNaN(fechaFin)) {
      fechaFin.setDate(fechaFin.getDate() + 1);
      endDate = fechaFin.toISOString().split("T")[0];
    }
    const filters = {
      searchQuery: busqueda,
      startDate: formDataFechaBusqueda.fechaI || null,
      endDate, // será null si no hay fecha
      isVenta: isCotizacion,
    };
    ventasrapidas(filters);
    setCurrentPage(0);

    navigate(`?search=${busqueda}`);
  };

  // Metodos para el popup de eliminar
  const handleCloseEliminar = () => setShowEliminar(false);
  const handleShowEliminar = (id) => {
    setId(id);
    setShowEliminar(true);
  };

  //Metodo para eliminar la venta
  const eliminarVenta = async () => {
    const { status, res } = await deleteVentaRapidas(id);
    const params = new URLSearchParams(location.search);
    const query = params.get("search") || "";
    setBusqueda(query);
    if (status === 200) {
      setShowEliminar(false);
      setAlert(true);
      setMensajealerta(res.msg);
      const filters = {
        isVenta: isCotizacion,
        searchQuery: query
      };
      ventasrapidas(filters);
    }

    setTimeout(() => {
      setAlert(false);
    }, 5000);
  };

  //---------------------------------//
  //------ Metodo editar Fecha ------//
  //---------------------------------//
  const handleShowFecha = (venta) => {
    setCurrentFactura(venta); // guardamos la venta actual
    setFormDataFecha({
      id_user: venta?.id || "", // 👈 asegurar string vacío si no existe
      fecha_vencimiento: venta?.fecha_vencimiento
        ? venta?.fecha_vencimiento.split("T")[0]
        : null,
      fecha_creacion: venta?.fecha_creacion
        ? venta?.fecha_creacion.split("T")[0]
        : venta?.createdAt.split("T")[0],
    });
    setId(venta?.id);
    setShowFechaModal(true);
  };

  const editarFechaVencimiento = async (e) => {
    e.preventDefault();
    try {
      const res = await editarFechaV(id, formDataFecha);
      const params = new URLSearchParams(location.search);
      const query = params.get("search") || "";
      setBusqueda(query);
      if (res.success) {
        setAlert(true);
        setMensajealerta(res.msg);
        const filters = {
          isVenta: isCotizacion,
          searchQuery: query
        };
        ventasrapidas(filters); // refresca la tabla de ventas
        setShowFechaModal(false);
      } else {
        setMensaje(res.msg);
      }
    } catch (error) {
      console.error(error);
      setMensaje("Error al actualizar la fecha");
    }
    setTimeout(() => {
      setAlert(false);
      setMensaje("");
    }, 3000);
  };


  const limpiarFilter = () => {
    setBusqueda("");
    setFormDataFechaBusqueda({ fechaI: "", fechaFin: "" });

    // Limpiar URL quitando todos los parámetros
    navigate(`?`);

    // volverte a traer la data sin filtros
    ventasrapidas({
      isVenta: isCotizacion,
      searchQuery: "",
      startDate: "",
      endDate: "",
    });
  }

  return (
    <Fragment>
      <div className="d-flex justify-content-center">
        <AlertComponent
          styleGroup="bg-soccess color-white"
          mensaje={mensajealerta}
          activaalert={alert}
        />
      </div>
      <HeaderComponent>
        <TitleH2Component styleGroup="box-text color-dark fw700 roboto mb-4">
          COTIZACION RAPIDAS
        </TitleH2Component>
        <Link to="/venta-rapida?tipo=cotizacion" className={`${stylebtn.btn} ${stylebtn.primary} `}>
          REALIZAR COTIZACION
        </Link>
      </HeaderComponent>

      {loading ? (
        <LoaderComponent styleGroup="mt-5" />
      ) : (
        <div className="conatiner-global pt-3 mb-5">
          <section>
            <div className="container">
              <form action="" onSubmit={handleFilterClick}>
                <div className="row gy-4 d-flex justify-content-end align-items-end">
                  <div className="col-12 col-md-6 col-xl-3">
                    <InputComponent
                      label="Fecha Inicio:"
                      styleLabel="fw600 WorkSans"
                      styleGroup="me-2"
                      htmlFor="bloque"
                      type="date"
                      name="fechaI"
                      value={formDataFechaBusqueda.fechaI}
                      onChange={handleInputChangeFechaBusqueda}
                    />
                  </div>
                  <div className="col-12 col-md-6 col-xl-3">
                    <InputComponent
                      label="Fecha Final:"
                      styleLabel="fw600 WorkSans"
                      styleGroup="me-2"
                      htmlFor="bloque"
                      type="date"
                      name="fechaFin"
                      value={formDataFechaBusqueda.fechaFin}
                      onChange={handleInputChangeFechaBusqueda}
                    />
                  </div>
                  <div className="col-12 col-md-6 col-xl-2">
                    <InputComponent
                      placeholder="Comprador"
                      label="Buscar Comprador"
                      styleLabel="fw600 WorkSans"
                      htmlFor="busqueda"
                      type="search"
                      name="busqueda"
                      value={busqueda}
                      onChange={handleChangeBusqueda}
                    />
                  </div>
                  <div className="col-12 col-md-6 col-lg-3  col-xl-2 d-flex justify-content-start">
                    <button
                      type="submit"
                      className={`${stylebtn.btn} ${stylebtn.primary}  mt-4`}
                    >
                      BUSCAR
                    </button>
                  </div>

                  <div className="col-12  col-lg-3 col-xl-2 d-flex justify-content-start">
                    <button type="button" className={`${stylebtn.btn} ${stylebtn.secundary} `} onClick={limpiarFilter}>Limpiar filtros</button>
                  </div>

                </div>
              </form>
            </div>
          </section>

          <section>
            <div className="table-responsive mt-4">
              <table className="table table-bordered tableGeneral">
                <thead>
                  <tr className="bg-light border-bottom border-2">
  <th scope="col" className="color-madera py-3 text-center" style={{ width: '40px' }}>
    <small className="fw-bold">#</small>
  </th>

  <th scope="col" className="color-madera py-3 text-nowrap">
    <i className="bi bi-hash me-1"></i>N° Factura
  </th>

  <th scope="col" className="color-madera py-3">
    Documento
  </th>

  <th scope="col" className="color-madera py-3 text-nowrap">
    Comprador
  </th>

  <th scope="col" className="color-madera py-3">
    Dirección
  </th>

  <th scope="col" className="color-madera py-3">
    Celular
  </th>

  {/* Columnas ocultas con d-none pero preparadas para el diseño */}
  <th scope="col" className="color-madera py-3 text-end d-none">
    Financiado
  </th>

  <th scope="col" className="color-madera py-3 text-end text-nowrap">
    Total
  </th>

  <th scope="col" className="color-madera py-3 text-center d-none">
    Fecha Pago
  </th>

  <th scope="col" className="color-madera py-3 text-center text-nowrap">
    <i className="bi bi-calendar3 me-1"></i>Fecha Factura
  </th>

  <th scope="col" className="color-madera py-3">
    Vendedor
  </th>

  <th scope="col" className="color-madera py-3 text-center d-none">
    Estado
  </th>

  {/* Columnas de acción */}
  <th scope="col" className="color-madera py-3 text-center" style={{ width: '50px' }}>
    Ver
  </th>
  
  <th scope="col" className="color-madera py-3 text-center" style={{ width: '50px' }}>
    Editar
  </th>

  <th scope="col" className="color-madera py-3 text-center text-danger" style={{ width: '50px' }}>
    <i className="bi bi-trash3"></i>
  </th>
</tr>
                </thead>
                {ventas.length > 0 ? (
                  <tbody>
                    {currentPageDateVR.map((venta, index) => {
                      return (
                        <tr key={index}>
                          <th>{index + 1}</th>
                          <th>{venta?.numeroFactura}</th>
                          <th>
                            {venta?.cedula || venta?.Cliente?.Persona?.cedula}
                          </th>
                          <td>
                            {venta?.nombre || venta?.Cliente?.Persona?.nombre}{" "}
                            {venta?.Cliente?.Persona?.apellido || ""}
                          </td>
                          <td>
                            {venta?.direccion ||
                              venta?.Cliente?.Persona?.direccion}
                          </td>
                          <td>
                            {venta?.telefono ||
                              venta?.Cliente?.Persona?.celular}
                          </td>
                          <td className="d-none">
                            {venta?.estado == 1
                              ? "$" +
                              Number(
                                Number(venta?.total ?? 0) +
                                Number(venta?.transporte ?? 0) -
                                venta?.total_pagado
                              ).toLocaleString("es-ES")
                              : "Paga"}
                          </td>
                          <td>
                            {" "}
                            $
                            {(
                              Number(venta?.total ?? 0) +
                              Number(venta?.transporte ?? 0)
                            ).toLocaleString("es-ES")}
                          </td>
                          <td className="d-none">{formatDateUTC(venta?.fecha_vencimiento)}</td>
                          <td>
                            {venta?.fecha_creacion
                              ? formatDateUTC(venta?.fecha_creacion)
                              : formatDate(venta?.createdAt)}
                          </td>

                          <td>
                            {venta?.User?.nombre || venta?.vendedor}
                          </td>
                          <td
                            className={`bg-azul color-white d-none`}
                          >
                            Cotizacion
                          </td>
                          <td className="text-center">
                            <Link
                              to={`/detalle-venta/${venta?.id}`}
                              className={`${stylebtn.btn_desnudo} ${stylebtn.icon} ms-3 p-0 d-inline-flex`}
                            >
                              <Icon icon="mdi:file-search-outline" />
                            </Link>
                          </td>
                          <td className="text-center">
                            <button
                              onClick={() => handleShowFecha(venta)}
                              className={`${stylebtn.btn_desnudo} ${stylebtn.icon} ms-3 p-0 d-inline-flex`}

                            >
                              <Icon
                                className={`color-dark`}
                                icon="lucide:calendar"
                              />
                            </button>
                          </td>
                          <td className="text-center">
                            <button
                              className={`${stylebtn.btn_desnudo} ${stylebtn.icon
                                } ms-3 p-0 d-inline-flex color-danger`}
                              onClick={() => handleShowEliminar(venta?.id)}
                            >
                              <Icon icon="majesticons:delete-bin" />
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                ) : (
                  <tbody>
                    <tr>
                      <td colSpan={12} className="text-center">
                        SIN VENTAS
                      </td>
                    </tr>
                  </tbody>
                )}
              </table>
            </div>
            {pageCount > 1 && (
              <PaginadorComponent
                setCurrentPage={setCurrentPage}
                pages={pageCount}
                styleGroup="d-flex justify-content-center pt-4"
              />
            )}
          </section>

          {/** modal editar Fecha de vencimiento**/}
          <ModalGeneralComponent
            styleGroup="d-flex align-items-center modal-general"
            styleTitle="box-text color-madera fw700 roboto text-center WorkSans"
            show={showFechaModal}
            handleClose={() => setShowFechaModal(false)}
          >
            <div className="container">
              <form onSubmit={editarFechaVencimiento}>
                <div className="d-flex align-items-start justify-content-between">
                  <div>
                    <TitleH4Component styleGroup="box-text color-dark fw700 roboto mb-1 text-center">
                      {currentFactura?.nombre}
                    </TitleH4Component>
                    <ParrafoComponent styleGroup="box-text color-dark fw700 roboto mb-1 text-center">
                      CC: {currentFactura?.cedula || currentFactura?.Cliente?.Persona?.cedula}
                    </ParrafoComponent>
                  </div>
                </div>

                <ParrafoComponent styleGroup="box-text color-danger fw700 roboto text-center">
                  {mensaje}
                </ParrafoComponent>

                <div className="row mb-4 gap-3 gap-md-0">
                  <div className="col-12 col-md-6 ">
                    <InputComponent
                      label="Fecha de pago"
                      type="date"
                      name="fecha_vencimiento"
                      value={formDataFecha.fecha_vencimiento}
                      onChange={handleInputChangeFecha}
                      className="form-control"
                    />
                  </div>

                  <div className="col-12 col-md-6">
                    <InputComponent
                      label="Fecha de facturación"
                      type="date"
                      name="fecha_creacion"
                      value={formDataFecha.fecha_creacion}
                      onChange={handleInputChangeFecha}
                      className="form-control"
                    />
                  </div>
                </div>

                <div className="d-flex w-100 justify-content-end">
                  <button
                    type="button"
                    className={`${stylebtn.btn_desnudo} ${stylebtn.line} p-0 me-3`}
                    onClick={() => setShowFechaModal(false)}
                  >
                    CANCELAR
                  </button>
                  <button
                    type="submit"
                    className={`btn ${stylebtn.btn} ${stylebtn.primary}`}
                  >
                    GUARDAR
                  </button>
                </div>
              </form>
            </div>
          </ModalGeneralComponent>

          {/** modal eliminar un producto del carrito **/}
          <section>
            <ModalGeneralComponent
              styleGroup="d-flex align-items-center modal-general "
              styleTitle={
                "box-text color-madera fw700 roboto text-center WorkSans"
              }
              show={showEliminar}
              handleClose={handleCloseEliminar}
            >
              <form action="">
                <TitleH2Component styleGroup="box-text color-madera fw700 roboto mb-4 text-center">{`Seguro que quiere eliminar la cotizacion`}</TitleH2Component>

                <div className="d-flex justify-content-end">
                  <button
                    type="button"
                    onClick={handleCloseEliminar}
                    className={`btn ${stylebtn.btn} ${stylebtn.danger} `}
                  >
                    Cancelar
                  </button>
                  <button
                    type="button"
                    className={`btn ${stylebtn.btn} ${stylebtn.primary} ms-3`}
                    onClick={eliminarVenta}
                  >
                    SI
                  </button>
                </div>
              </form>
            </ModalGeneralComponent>
          </section>
        </div>
      )}
    </Fragment>
  );
};

export default CotizacionRealizadasPages;